import { gql } from '@apollo/client';

const sortingDashboardItemFields = `
    fragment SortingDashboardItemFields on SortingDashboardItemType {
        timePeriod
        hubId
        sortingCode
        inboundCount
        inboundWrongSortDenominatorCount
        shouldArriveNotArriveRate
        shouldArriveNotArriveCount
        outbound12hRate
        ascanMissRate
        transferArrivalMissRate
        transferArrivalDscanCount
        transferArrivalMissCount
        dscanCount
        ascanMissCount
        outboundMissRate
        outboundMissCount
        wrongSortRate
        wrongSortCount
        wrongSortToWrongHubACount
        wrongSortToWrongWhsBCount
        wrongSortToWrongLineCCount
        lostDamagedRate
        lostDamagedCount
        sortEfficiency
        sortPeak
        overallMissScanRate
        nextDayHandoverRate
        nextDayHandoverCount
        crossBorderOnline24hRate
        crossBorderOnline24hCount
        crossBorderHandoverCount
        notCorrectlyPackedCount
        bagLabelNotShippedCount
        noDepartureActionCount
    }
`;

const sortingDashboardAggregateFields = `
    fragment SortingDashboardAggregateFields on SortingDashboardAggregateItemType {
        hubId
        sortingCode
        inboundCount
        inboundWrongSortDenominatorCount
        shouldArriveNotArriveRate
        shouldArriveNotArriveCount
        outbound12hRate
        ascanMissRate
        transferArrivalMissRate
        transferArrivalDscanCount
        transferArrivalMissCount
        dscanCount
        ascanMissCount
        outboundMissRate
        outboundMissCount
        wrongSortRate
        wrongSortCount
        wrongSortToWrongHubACount
        wrongSortToWrongWhsBCount
        wrongSortToWrongLineCCount
        lostDamagedRate
        lostDamagedCount
        sortEfficiency
        sortPeak
        overallMissScanRate
        nextDayHandoverRate
        nextDayHandoverCount
        crossBorderOnline24hRate
        crossBorderOnline24hCount
        crossBorderHandoverCount
        notCorrectlyPackedCount
        bagLabelNotShippedCount
        noDepartureActionCount
        inboundCountChange
        shouldArriveNotArriveRateChange
        outbound12hRateChange
        ascanMissRateChange
        transferArrivalMissRateChange
        outboundMissRateChange
        wrongSortRateChange
        lostDamagedRateChange
        sortEfficiencyChange
        sortPeakChange
        overallMissScanRateChange
        nextDayHandoverRateChange
    }
`;

export const QUERY_SORTING_DASHBOARD = gql`
    ${sortingDashboardItemFields}
    ${sortingDashboardAggregateFields}
    query QuerySortingDashboard($input: SortingDashboardQueryInput!) {
        querySortingDashboard(input: $input) {
            items {
                ...SortingDashboardItemFields
            }
            aggregate {
                ...SortingDashboardAggregateFields
            }
            customerSlices {
                customerName
                items {
                    ...SortingDashboardItemFields
                }
                aggregate {
                    ...SortingDashboardAggregateFields
                }
            }
            latestCalculatedAt
        }
    }
`;
